import React, { type ReactNode } from 'react';

import { type NftCardSectionVariant } from '../../types';

import { StyledSection } from './styles';

export interface SectionProps {
    children: ReactNode;
    variant?: NftCardSectionVariant;
}

export function Section({ children, variant }: SectionProps) {
    return <StyledSection $variant={variant}>{children}</StyledSection>;
}
